(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dm-product-grid"] && !Shopify.designMode) return;
  try {
    (function () {
  // Show or hide prev/next buttons based on current scroll position.
  // A 4px tolerance handles sub-pixel rounding in browser scroll calculations.
  function updateButtons(carousel) {
    const track = carousel.querySelector('[data-dm-track]');
    const prev = carousel.querySelector('[data-dm-prev]');
    const next = carousel.querySelector('[data-dm-next]');
    if (!track) return;
    const atStart = track.scrollLeft <= 4;
    const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    if (prev) prev.hidden = atStart;  // Hide prev at the beginning
    if (next) next.hidden = atEnd;    // Hide next at the end
  }

  // Handle prev/next button clicks — scroll by one card width + gap
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-dm-prev], [data-dm-next]');
    if (!button) return;
    const carousel = button.closest('[data-dm-carousel]');
    const track = carousel && carousel.querySelector('[data-dm-track]');
    if (!track) return;
    const item = track.querySelector('.dm-product-grid__item');
    const amount = item ? item.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
    track.scrollBy({ left: button.hasAttribute('data-dm-prev') ? -amount : amount, behavior: 'smooth' });
  });

  // Update button visibility as the track scrolls.
  // Uses capture phase (true) to catch the scroll event on the track element itself.
  document.addEventListener('scroll', (event) => {
    const track = event.target;
    if (!track.matches || !track.matches('[data-dm-track]')) return;
    const carousel = track.closest('[data-dm-carousel]');
    if (carousel) updateButtons(carousel);
  }, true);

  // Initialise all carousels present at page load
  document.querySelectorAll('[data-dm-carousel]').forEach(updateButtons);

  // Re-initialise carousels added dynamically — needed for the Shopify theme
  // editor Customize preview, which inserts sections without a full page reload
  if (window.MutationObserver) {
    new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          node.querySelectorAll('[data-dm-carousel]').forEach(updateButtons);
          if (node.matches && node.matches('[data-dm-carousel]')) updateButtons(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gift-card-recipient"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-gift-card-recipient]').forEach(function (wrapper) {
    var toggle = wrapper.querySelector('[data-recipient-toggle]');
    var fields = wrapper.querySelector('[data-recipient-fields]');
    var offset = wrapper.querySelector('[data-recipient-offset]');
    var inputs = fields.querySelectorAll('input, textarea');

    if (offset) {
      offset.value = new Date().getTimezoneOffset();
    }

    function sync() {
      var on = toggle.checked;
      fields.hidden = !on;
      inputs.forEach(function (input) {
        input.disabled = !on;
      });
    }

    toggle.addEventListener('change', sync);
    sync();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-image-zoom"] && !Shopify.designMode) return;
  try {
    (function(){
    var overlay = document.getElementById('product-image-zoom');
    if (!overlay) return;

    var slides    = overlay.querySelectorAll('.zoom-slide');
    var thumbs    = overlay.querySelectorAll('.zoom-thumbs li');
    var thumbBtns = overlay.querySelectorAll('.zoom-thumbs button');
    var dots      = overlay.querySelectorAll('.zoom-dots button');
    var prevBtn   = overlay.querySelector('.zoom-prev');
    var nextBtn   = overlay.querySelector('.zoom-next');
    var closeBtn  = overlay.querySelector('.zoom-close');
    var total     = slides.length;
    var current   = 0;
    var lastFocus = null;

    function getVisibleFocusable(){
      var nodes = overlay.querySelectorAll('a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled])');
      var out = [];
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].offsetParent !== null) out.push(nodes[i]);
      }
      return out;
    }

    function setActive(index){
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      current = index;
      for (var i = 0; i < total; i++) {
        slides[i].classList.toggle('active', i === index);
        if (thumbs[i]) thumbs[i].classList.toggle('active', i === index);
        if (dots[i])   dots[i].classList.toggle('active', i === index);
      }
    }

    function open(startIndex){
      lastFocus = document.activeElement;
      setActive(startIndex || 0);
      overlay.classList.add('open');
      overlay.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function close(){
      overlay.classList.remove('open');
      overlay.setAttribute('hidden', '');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    function onKeydown(e){
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key === 'ArrowLeft')  { setActive(current - 1); return; }
      if (e.key === 'ArrowRight') { setActive(current + 1); return; }
      if (e.key === 'Tab') {
        var focusable = getVisibleFocusable();
        if (focusable.length === 0) { e.preventDefault(); return; }
        var first = focusable[0];
        var last  = focusable[focusable.length - 1];
        var active = document.activeElement;
        var inside = overlay.contains(active);
        if (e.shiftKey) {
          if (!inside || active === first) { last.focus(); e.preventDefault(); }
        } else {
          if (!inside || active === last) { first.focus(); e.preventDefault(); }
        }
      }
    }

    var imageLis = [];
    var allLis = document.querySelectorAll('#product-detail .photos .large .slides > li');
    for (var i = 0; i < allLis.length; i++) {
      if (allLis[i].getAttribute('data-media-type') === 'image') imageLis.push(allLis[i]);
    }
    imageLis.forEach(function(li, idx){
      var img = li.querySelector('img');
      if (!img) return;
      img.addEventListener('click', function(){ open(idx); });
    });

    Array.prototype.forEach.call(thumbBtns, function(btn){
      btn.addEventListener('click', function(){
        setActive(parseInt(btn.getAttribute('data-index'), 10));
      });
    });
    Array.prototype.forEach.call(dots, function(btn){
      btn.addEventListener('click', function(){
        setActive(parseInt(btn.getAttribute('data-index'), 10));
      });
    });
    if (prevBtn) prevBtn.addEventListener('click', function(){ setActive(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function(){ setActive(current + 1); });
    closeBtn.addEventListener('click', close);

    overlay.addEventListener('click', function(e){
      if (e.target === overlay || e.target.classList.contains('zoom-stage') || e.target.classList.contains('zoom-slide')) {
        close();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
